import React, { useState, useEffect } from "react";
import {
  AccountInfo,
  InteractionRequiredAuthError,
  PublicClientApplication,
} from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig, selfServiceApiScopes } from "./authConfig";
import LoadingComponent from "./authLoading";
import api from "../axios/axios";

interface IMsalProviderWrapperProps {
  children: React.ReactNode;
}

const AuthProvider: React.FC<IMsalProviderWrapperProps> = ({ children }) => {
  const msalInstance = new PublicClientApplication(msalConfig);
  const [isMsalInitialized, setIsMsalInitialized] = useState(false);

  const initializeAxiosAuth = async (account: AccountInfo) => {
    const request = {
      account: account,
      scopes: selfServiceApiScopes,
    };

    const { accessToken } = await msalInstance.acquireTokenSilent(request);
    const bearer = `Bearer ${accessToken}`;
    api.defaults.headers.common["Authorization"] = bearer;
  };

  const lazyMSALInitializer = async () => {
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise();
    const accounts = await msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      await msalInstance.loginRedirect().catch(async (e) => {
        if (e instanceof InteractionRequiredAuthError) {
          await msalInstance.loginRedirect();
        }
        console.error(e);
      });
    } else {
      await initializeAxiosAuth(accounts[0]);
      setIsMsalInitialized(true);
    }
  };

  useEffect(() => {
    lazyMSALInitializer().catch((e) => console.log(e));
  }, [lazyMSALInitializer]);

  if (!isMsalInitialized) {
    return <LoadingComponent />;
  }

  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};

export default AuthProvider;
